module.exports = __webpack_public_path__ + "images/footerBg.ea24fbdf.webp";